// extracted by mini-css-extract-plugin
export default {"page":"Login_page__yXPXa","container":"Login_container__-h4N5","logoBanner":"Login_logoBanner__i3TuI","logo":"Login_logo__tBTNk","colorSpan":"Login_colorSpan__4RZQ1"};